import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "my-feature-flag-called-events-dont-show-my-variant-names"
    }}>{`My feature flag called events don't show my variant names`}</h2>
    <p><inlineCode parentName="p">{`Feature Flag Called`}</inlineCode>{` events showing `}<inlineCode parentName="p">{`None`}</inlineCode>{`, `}<inlineCode parentName="p">{`(empty string)`}</inlineCode>{`, or `}<inlineCode parentName="p">{`false`}</inlineCode>{` instead of your variant names has two potential causes:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Your feature flag did not match any of the rollout conditions. If this is the case, the `}<inlineCode parentName="p">{`Feature Flag Response`}</inlineCode>{` property will be false `}<inlineCode parentName="p">{`false`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The feature flag is disabled or failed to load. The variant names will show as `}<inlineCode parentName="p">{`None`}</inlineCode>{` or `}<inlineCode parentName="p">{`(empty string)`}</inlineCode>{` if this is the case. This can happen due to a network error, adblocking, or something unexpected. `}<inlineCode parentName="p">{`(empty string)`}</inlineCode>{` also appears when some of the events for an experiment lack feature flag information.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      